/**
 * CL Pagination — input "ir a la página"
 *
 * snippets/cl-theme-pagination.liquid se usa en muchas secciones distintas
 * (collection, search, blog, blog-post, account, addresses, etc.), así que
 * en vez de registrar este comportamiento por tipo de sección, usamos un
 * único listener delegado en document. Se registra una sola vez al cargar
 * este archivo y sigue funcionando aunque el HTML de adentro se reemplace
 * por AJAX en el editor de temas (a diferencia de un <script> inline pegado
 * dentro de la sección, que no se re-ejecutaría en ese caso).
 *
 * Archivo separado de theme.js (bundle del tema) a propósito: es lógica
 * propia del proyecto, no del tema base.
 */
(function () {
  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-cl-pagination-goto]");
    if (!form) {
      return;
    }
    event.preventDefault();

    var input = form.querySelector("[data-cl-pagination-goto-input]");
    var page = parseInt(input.value, 10);
    var max = parseInt(input.max, 10);

    if (!page || page < 1) {
      page = 1;
    }
    if (max && page > max) {
      page = max;
    }

    var url = new URL(window.location.href);
    url.searchParams.set("page", page);
    window.location.href = url.toString();
  });
})();
